export const articles = [
  {
    id: 1,
    slug: 'sansui-yingyang-peifang',
    title: '悠宝三岁营养配方：3岁宝宝每日所需营养全解析',
    excerpt: '3岁是宝宝生长发育的黄金期，合理的营养摄入对大脑发育、骨骼生长至关重要。悠宝三岁营养方案根据中国营养学会推荐标准，为3岁宝宝量身定制每日营养计划。',
    content: `<p>3岁是宝宝从婴幼儿向学龄前过渡的关键时期，这个阶段的营养需求与1-2岁时有明显不同。悠宝三岁营养研究团队基于国内外最新营养学研究，结合中国宝宝的体质特点，开发了一套科学、均衡的营养方案。</p>
    <h2>3岁宝宝每日核心营养素需求</h2>
    <p>根据《中国居民膳食营养素参考摄入量（2023版）》，3岁儿童每日所需核心营养素包括：蛋白质30-35g、钙600-800mg、铁9mg、锌5.5mg、维生素D 10μg。悠宝三岁营养配方精确匹配这些标准，确保宝宝获得全面均衡的营养。</p>
    <h2>悠宝三岁营养方案的三大支柱</h2>
    <p><strong>1. 优质蛋白来源</strong>：精选深海鱼、有机鸡蛋、优质牛奶，提供易于吸收的完全蛋白质，支持肌肉和免疫系统发育。</p>
    <p><strong>2. 脑黄金DHA+ARA</strong>：科学配比的DHA与ARA，促进大脑神经元连接，提升认知能力和记忆力。悠宝三岁采用藻油来源DHA，纯度高、无污染。</p>
    <p><strong>3. 益生元+膳食纤维</strong>：添加FOS/GOS益生元组合，搭配天然果蔬膳食纤维，维护肠道微生态平衡，提升营养吸收率。</p>
    <h2>真实妈妈反馈</h2>
    <p>来自上海的李妈妈分享："自从使用悠宝三岁营养方案后，宝宝吃饭更香了，身高体重增长都达到了标准曲线的上限，体检时医生都夸发育得好！"</p>
    <p>悠宝三岁，用科学守护每一个3岁宝宝的健康成长。</p>`,
    category: 'yingyang',
    categoryName: '营养方案',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20colorful%20healthy%20children%20food%20bowl%20with%20fruits%20vegetables%20and%20milk%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20flat%20lay%20food%20photography%20with%20pastel%20warm%20tones%2C%20playful%20composition%20with%20wooden%20table%20texture&width=800&height=500&seq=article-yingyang-01&orientation=landscape',
    author: '悠宝营养师团队',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['营养方案', '3岁宝宝', '科学喂养']
  },
  {
    id: 2,
    slug: 'sansui-zaojiao-fangan',
    title: '悠宝三岁早教方案：抓住3岁认知爆发期的教育秘诀',
    excerpt: '3岁是语言能力、逻辑思维和社交情感发展的关键窗口期。悠宝三岁早教方案基于蒙台梭利教育理念，设计了一套在家就能进行的科学早教体系。',
    content: `<p>科学研究表明，3岁时儿童大脑重量已达到成人的85%，神经元连接数量是成人的2倍。这个阶段是认知能力的"爆发期"，恰当的教育刺激将对孩子的终身学习能力产生深远影响。</p>
    <h2>悠宝三岁早教的核心理念</h2>
    <p>悠宝三岁早教方案秉持"玩中学、学中玩"的理念，将蒙台梭利、瑞吉欧等国际先进教育理念本土化，打造适合中国家庭的早教体系。我们相信，最好的早教不是填鸭式的知识灌输，而是激发孩子与生俱来的好奇心和探索欲。</p>
    <h2>五大能力培养体系</h2>
    <p><strong>语言表达能力</strong>：通过绘本阅读、儿歌互动、角色扮演等方式，丰富词汇量，培养语言组织和表达能力。</p>
    <p><strong>逻辑思维能力</strong>：利用分类游戏、拼图、积木搭建等活动，建立基本的逻辑推理和问题解决能力。</p>
    <p><strong>精细动作能力</strong>：通过剪纸、串珠、捏泥等手工活动，锻炼手眼协调和手指灵活性。</p>
    <p><strong>社交情感能力</strong>：设计合作游戏、情绪识别卡片等活动，帮助宝宝认识和管理情绪，学会分享与合作。</p>
    <p><strong>艺术创造力</strong>：提供安全的绘画材料、音乐玩具，鼓励自由表达，保护宝宝的想象力和创造力。</p>
    <h2>一天30分钟，轻松在家早教</h2>
    <p>悠宝三岁早教方案每天只需30分钟，将早教融入日常生活的每个环节。从早晨的问候歌到睡前的绘本时间，让亲子互动变得更加有质量、有温度。</p>`,
    category: 'zaojiao',
    categoryName: '早教方案',
    coverImage: 'https://readdy.ai/api/search-image?query=Adorable%20three%20year%20old%20child%20playing%20with%20colorful%20educational%20toys%20on%20warm%20wooden%20floor%2C%20soft%20sunlight%20streaming%20through%20window%2C%20Montessori%20style%20playroom%20with%20natural%20materials%2C%20warm%20cream%20and%20beige%20interior%2C%20cozy%20atmosphere&width=800&height=500&seq=article-zaojiao-02&orientation=landscape',
    author: '悠宝早教研发中心',
    date: '2026-07-10',
    readTime: '10分钟',
    tags: ['早教方案', '认知发展', '亲子互动']
  },
  {
    id: 3,
    slug: 'sansui-xiguan-peiyang',
    title: '悠宝三岁习惯培养：21天帮宝宝建立良好生活习惯',
    excerpt: '3岁是习惯养成的黄金年龄。悠宝三岁习惯培养方案通过科学的奖励机制和趣味打卡方式，帮助宝宝在21天内建立良好的饮食、睡眠、卫生习惯。',
    content: `<p>俗话说"三岁看大，七岁看老"，3岁时养成的习惯往往会伴随孩子一生。悠宝三岁联合儿童心理学专家，开发了一套适合3岁宝宝的"21天好习惯养成计划"。</p>
    <h2>为什么是21天？</h2>
    <p>心理学研究表明，形成一个稳定的行为习惯平均需要21天。悠宝三岁将这一理论应用于儿童习惯培养，设计了分阶段、渐进式的习惯养成路径。</p>
    <h2>悠宝三岁四大习惯培养模块</h2>
    <p><strong>饮食习惯</strong>：自己吃饭不挑食、细嚼慢咽、餐前洗手。通过可爱的餐具和趣味食物造型，让吃饭变成一件开心的事。</p>
    <p><strong>睡眠习惯</strong>：固定作息时间、独立入睡、睡前仪式。悠宝三岁设计了专属的睡前故事和安抚音乐，帮助宝宝建立安全感。</p>
    <p><strong>卫生习惯</strong>：早晚刷牙、自己洗手、整理玩具。通过互动游戏和可爱的习惯打卡表，让宝宝主动爱上讲卫生。</p>
    <p><strong>社交习惯</strong>：礼貌用语、轮流等待、分享玩具。在日常互动中潜移默化地培养宝宝的社交礼仪。</p>
    <h2>趣味打卡，快乐养成</h2>
    <p>悠宝三岁特别设计了星星奖励系统和习惯打卡日历，每完成一个习惯就能获得一颗星星，集满星星可以兑换小奖励。这种正向激励让宝宝在快乐中自然而然地养成好习惯。</p>`,
    category: 'xiguan',
    categoryName: '习惯培养',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20three%20year%20old%20child%20brushing%20teeth%20happily%20in%20bright%20bathroom%20with%20warm%20lighting%2C%20adorable%20children%20daily%20routine%20scene%2C%20clean%20minimalist%20bathroom%20with%20soft%20cream%20tiles%2C%20morning%20sunlight%2C%20warm%20and%20playful%20atmosphere&width=800&height=500&seq=article-xiguan-03&orientation=landscape',
    author: '悠宝育儿专家组',
    date: '2026-07-05',
    readTime: '7分钟',
    tags: ['习惯培养', '21天计划', '育儿方法']
  },
  {
    id: 4,
    slug: 'sansui-yundong-zhinan',
    title: '悠宝三岁运动指南：适合3岁宝宝的运动方式和运动量',
    excerpt: '适当的运动对3岁宝宝的身体发育、协调能力和自信心培养至关重要。悠宝三岁运动指南为您推荐最适合3岁宝宝的运动项目和每日运动量。',
    content: `<p>世界卫生组织建议，3-4岁儿童每天应进行至少180分钟的身体活动，其中至少60分钟应为中等强度活动。悠宝三岁运动研究团队结合中国宝宝的身体特点，制定了科学的运动指导方案。</p>
    <h2>3岁宝宝运动能力发展里程碑</h2>
    <p>3岁宝宝通常已经能够：双脚跳、单脚站立3-5秒、踢球、骑三轮车、上下楼梯交替迈步。悠宝三岁运动方案针对这些发展指标，设计了循序渐进的运动游戏。</p>
    <h2>推荐运动项目TOP5</h2>
    <p><strong>1. 趣味平衡游戏</strong>：走直线、单脚站立比赛、平衡木游戏，提升本体感觉和前庭功能。</p>
    <p><strong>2. 球类运动</strong>：踢球、接球、滚球，锻炼手眼协调和全身协调能力。</p>
    <p><strong>3. 爬行探险</strong>：钻山洞、爬垫子、攀爬架，发展大肌肉群力量和空间感知。</p>
    <p><strong>4. 舞蹈律动</strong>：跟随音乐自由舞动，培养节奏感和身体表达能力。</p>
    <p><strong>5. 自然探索</strong>：户外散步、捡树叶、追泡泡，在自然中释放天性。</p>
    <h2>运动安全须知</h2>
    <p>悠宝三岁提醒各位家长：运动前做好热身，选择安全的场地和器材，注意补水，避免在极端天气下进行户外运动。最重要的是，让运动充满乐趣，不要给孩子施加压力。</p>`,
    category: 'yingyang',
    categoryName: '营养方案',
    coverImage: 'https://readdy.ai/api/search-image?query=Happy%20three%20year%20old%20child%20running%20and%20playing%20in%20sunny%20green%20park%20with%20colorful%20ball%2C%20warm%20golden%20afternoon%20light%2C%20natural%20outdoor%20scene%20with%20soft%20bokeh%20background%2C%20active%20healthy%20lifestyle&width=800&height=500&seq=article-yundong-04&orientation=landscape',
    author: '悠宝运动健康师',
    date: '2026-06-28',
    readTime: '6分钟',
    tags: ['运动指南', '身体发育', '亲子运动']
  },
  {
    id: 5,
    slug: 'sansui-yuyan-fazhan',
    title: '悠宝三岁语言发展：如何帮助3岁宝宝提升表达能力',
    excerpt: '3岁是语言发展的"爆发期"，词汇量从300个迅速增长到1000个以上。悠宝三岁早教方案中的语言发展模块，为家长提供科学的语言启蒙方法。',
    content: `<p>研究表明，3岁时儿童的语言能力与未来的学业成绩高度相关。悠宝三岁语言发展方案融合了语言学家和儿童发展心理学家的研究成果，为家长提供了一套简单易行的语言启蒙方法。</p>
    <h2>3岁语言发展里程碑</h2>
    <p>3岁宝宝通常能够：说3-5个词的句子、使用代词"你我他"、理解简单的故事、问"为什么"、能说出自己的名字和年龄。如果宝宝的语言发展明显滞后，建议及时咨询专业医生。</p>
    <h2>悠宝三岁推荐的语言启蒙方法</h2>
    <p><strong>绘本共读法</strong>：每天15分钟的绘本共读，不仅能增加词汇量，还能培养阅读兴趣和理解能力。悠宝三岁精选了100本适合3岁宝宝的优质绘本。</p>
    <p><strong>儿歌互动法</strong>：节奏明快的儿歌有助于语音感知和记忆。边唱边做动作，让语言学习变得更加生动有趣。</p>
    <p><strong>描述性对话法</strong>：在日常生活中多使用描述性的语言，如"妈妈在切红色的苹果"，而不是简单的"嗯"。</p>
    <p><strong>开放式提问法</strong>：多问"你觉得呢？""为什么呀？"引导宝宝思考和表达，而不是简单的"是不是"。</p>`,
    category: 'zaojiao',
    categoryName: '早教方案',
    coverImage: 'https://readdy.ai/api/search-image?query=Mother%20reading%20colorful%20picture%20book%20with%20cute%20three%20year%20old%20child%20on%20cozy%20sofa%2C%20warm%20home%20interior%20with%20soft%20natural%20light%2C%20comfortable%20cream%20and%20beige%20decor%2C%20intimate%20parenting%20moment%2C%20bookshelf%20background&width=800&height=500&seq=article-yuyan-05&orientation=landscape',
    author: '悠宝语言教育专家',
    date: '2026-06-20',
    readTime: '9分钟',
    tags: ['语言发展', '绘本阅读', '亲子沟通']
  },
  {
    id: 6,
    slug: 'sansui-shuimian-zhiyin',
    title: '悠宝三岁睡眠指引：如何让3岁宝宝拥有高质量睡眠',
    excerpt: '充足的睡眠是3岁宝宝生长发育的基础。悠宝三岁睡眠指引帮助家长了解3岁宝宝的睡眠需求，建立科学的睡眠习惯，让宝宝和全家人都能睡个好觉。',
    content: `<p>3岁宝宝每天需要10-13小时的睡眠（包括午睡）。睡眠不仅关系到身高体重的增长，更影响大脑发育、情绪调节和免疫力。悠宝三岁睡眠研究团队结合儿童睡眠医学最新进展，为家长提供全面的睡眠指导。</p>
    <h2>3岁宝宝常见睡眠问题</h2>
    <p>很多家长反映3岁宝宝出现：入睡困难、夜醒频繁、拒绝午睡、早醒等问题。这些问题往往不是疾病，而是睡眠习惯和环境需要调整的信号。</p>
    <h2>悠宝三岁睡眠优化方案</h2>
    <p><strong>建立固定的睡前仪式</strong>：洗澡→换睡衣→读绘本→关灯→说晚安，每天按照相同的顺序和时间进行，让宝宝的身体形成条件反射。</p>
    <p><strong>打造舒适的睡眠环境</strong>：室温保持在22-24℃，湿度50%-60%，使用遮光窗帘，保持安静（可播放白噪音）。</p>
    <p><strong>合理安排日间活动</strong>：充足的日间运动有助于夜间睡眠，但避免在睡前2小时内进行剧烈活动。</p>
    <p><strong>控制屏幕时间</strong>：睡前1小时避免接触手机、平板、电视等电子屏幕，蓝光会抑制褪黑素分泌。</p>
    <p>悠宝三岁，守护每一个甜美的梦乡。</p>`,
    category: 'xiguan',
    categoryName: '习惯培养',
    coverImage: 'https://readdy.ai/api/search-image?query=Peaceful%20three%20year%20old%20child%20sleeping%20soundly%20in%20cozy%20bed%20with%20soft%20blanket%20and%20warm%20night%20light%2C%20dreamy%20bedroom%20with%20cream%20walls%20and%20star%20decorations%2C%20gentle%20warm%20lighting%2C%20calm%20and%20serene%20atmosphere&width=800&height=500&seq=article-shuimian-06&orientation=landscape',
    author: '悠宝睡眠研究中心',
    date: '2026-06-15',
    readTime: '7分钟',
    tags: ['睡眠指引', '作息规律', '睡眠环境']
  }
];

export const faqs = [
  {
    question: '悠宝三岁适合多大的宝宝使用？',
    answer: '悠宝三岁专为2.5岁至3.5岁的宝宝设计，核心方案针对3岁（36个月）左右的儿童。部分早教和营养方案也适用于2岁半开始启蒙、4岁继续深化的孩子，具体可根据宝宝的发育情况灵活调整。'
  },
  {
    question: '悠宝三岁的营养方案是否安全？',
    answer: '悠宝三岁营养方案由注册营养师和儿科医生联合研发，严格遵循《中国居民膳食营养素参考摄入量》标准。所有营养成分配比经过科学验证，不添加任何人工色素、香精和防腐剂，请放心使用。'
  },
  {
    question: '早教方案需要家长全程陪同吗？',
    answer: '悠宝三岁早教方案设计了"亲子共学"和"自主探索"两种模式。亲子共学环节建议家长积极参与，增进亲子关系；自主探索环节可以让宝宝独立完成，培养专注力和独立性。每天总时长约30分钟，灵活安排。'
  },
  {
    question: '习惯培养的21天计划失败了怎么办？',
    answer: '育儿没有失败，只有调整。如果21天计划没有达到预期效果，建议先观察是哪个环节出现了问题——是宝宝不适应？还是执行方式需要调整？悠宝三岁提供了一对一的育儿顾问服务，可以根据宝宝的实际情况调整方案，重新开始计划。'
  },
  {
    question: '悠宝三岁的方案可以和其他早教机构一起使用吗？',
    answer: '完全可以！悠宝三岁方案是家庭场景下的补充方案，与线下早教机构形成互补。我们建议将悠宝三岁的日常方案与机构的社交活动相结合，让宝宝在家庭和社交场景中都能得到全面的发展。'
  },
  {
    question: '如何购买悠宝三岁的产品？有试用装吗？',
    answer: '您可以通过悠宝三岁官方小程序或官网商城购买。我们为新用户提供7天体验装，只需支付邮费即可体验悠宝三岁的核心方案。体验满意后再购买正式套装。具体可咨询我们的客服热线400-123-4567。'
  },
  {
    question: '悠宝三岁有退款政策吗？',
    answer: '我们提供30天无忧退款保障。如果您在使用悠宝三岁方案后不满意，在购买后30天内可申请全额退款。我们对自己的产品充满信心，也希望每一位家长都能安心尝试。'
  }
];

export const testimonials = [
  {
    id: 1,
    name: '晓彤妈妈',
    city: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20smiling%20young%20Chinese%20mother%20portrait%20with%20soft%20natural%20lighting%2C%20minimalist%20headshot%20on%20cream%20background%2C%20gentle%20expression&width=100&height=100&seq=avatar-mom-01&orientation=squarish',
    content: '宝宝用了悠宝三岁的营养方案两个月，挑食的毛病改善了好多！现在每餐都能乖乖吃完，身高长了不少，太开心了！',
    rating: 5
  },
  {
    id: 2,
    name: '辰辰爸爸',
    city: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20father%20portrait%20with%20warm%20smile%2C%20minimalist%20headshot%20on%20cream%20background%2C%20approachable%20expression&width=100&height=100&seq=avatar-dad-02&orientation=squarish',
    content: '早教方案真的科学又实用！每天下班回家陪孩子玩半小时，明显感觉他语言表达进步了很多，会说好多新词了。',
    rating: 5
  },
  {
    id: 3,
    name: '乐乐奶奶',
    city: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Kind%20elderly%20Chinese%20grandmother%20portrait%20with%20warm%20smile%2C%20minimalist%20headshot%20on%20cream%20background%2C%20gentle%20loving%20expression&width=100&height=100&seq=avatar-grandma-03&orientation=squarish',
    content: '我是帮忙带孙子的，悠宝三岁的习惯培养方案简单易懂，连我这个老人家都能操作。孙子的作息规律多了，全家人都轻松了！',
    rating: 5
  }
];

export const categories = [
  {
    id: 'yingyang',
    name: '营养方案',
    icon: 'ri-heart-pulse-line',
    description: '科学营养搭配，护航宝宝健康成长',
    color: 'primary',
    articles: [1, 4]
  },
  {
    id: 'zaojiao',
    name: '早教方案',
    icon: 'ri-lightbulb-line',
    description: '抓住认知爆发期，激发宝宝无限潜能',
    color: 'accent',
    articles: [2, 5]
  },
  {
    id: 'xiguan',
    name: '习惯培养',
    icon: 'ri-star-line',
    description: '21天好习惯养成，受益一生的礼物',
    color: 'secondary',
    articles: [3, 6]
  }
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '科学权威',
    description: '联合儿科专家、营养师、早教专家共同研发，基于最新科研成果'
  },
  {
    icon: 'ri-user-heart-line',
    title: '个性定制',
    description: '根据每个宝宝的发育情况和性格特点，提供专属成长方案'
  },
  {
    icon: 'ri-home-smile-line',
    title: '在家轻松做',
    description: '无需奔波，每天30分钟在家陪伴，亲子时光更有质量'
  },
  {
    icon: 'ri-bar-chart-line',
    title: '成长可视化',
    description: '每周成长报告，记录宝宝的每一点进步，让成长有迹可循'
  }
];

export const solutions = [
  {
    id: 'yingyang',
    title: '营养方案',
    subtitle: '均衡营养，健康成长',
    description: '基于中国营养学会推荐标准，为3岁宝宝量身定制每日营养计划。涵盖优质蛋白、DHA、益生元等核心营养素，科学配比，全面均衡。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20healthy%20children%20meal%20plate%20with%20fruits%20vegetables%20eggs%20and%20milk%20on%20warm%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimalist%20food%20photography%20with%20warm%20cream%20background%2C%20playful%20arrangement&width=600&height=400&seq=solution-yingyang&orientation=landscape',
    features: ['蛋白质30-35g/日', 'DHA+ARA脑黄金', '益生元肠道呵护', '钙铁锌全面补充']
  },
  {
    id: 'zaojiao',
    title: '早教方案',
    subtitle: '玩中学，学中玩',
    description: '融合蒙台梭利、瑞吉欧国际教育理念，打造适合中国家庭的早教体系。五大能力培养体系：语言、逻辑、精细动作、社交情感、艺术创造。',
    image: 'https://readdy.ai/api/search-image?query=Cute%20child%20playing%20with%20colorful%20Montessori%20wooden%20educational%20toys%20on%20warm%20floor%2C%20soft%20sunlight%2C%20minimalist%20playroom%20with%20natural%20materials%2C%20warm%20cream%20interior%2C%20creative%20learning%20atmosphere&width=600&height=400&seq=solution-zaojiao&orientation=landscape',
    features: ['语言表达能力', '逻辑思维能力', '精细动作训练', '社交情感启蒙', '艺术创造培养']
  },
  {
    id: 'xiguan',
    title: '习惯培养',
    subtitle: '21天，受益一生',
    description: '联合儿童心理学专家，开发21天好习惯养成计划。覆盖饮食、睡眠、卫生、社交四大模块，通过趣味打卡和星星奖励，让习惯养成变得快乐自然。',
    image: 'https://readdy.ai/api/search-image?query=Adorable%20three%20year%20old%20child%20happily%20tidying%20up%20colorful%20toys%20in%20bright%20minimalist%20living%20room%2C%20warm%20sunlight%20streaming%20in%2C%20organized%20playroom%20with%20cream%20walls%20and%20natural%20wood%20furniture&width=600&height=400&seq=solution-xiguan&orientation=landscape',
    features: ['饮食习惯养成', '睡眠规律建立', '卫生好习惯', '社交礼仪培养', '星星奖励系统']
  }
];